export default {
    created() {
        let that = this;

        document.addEventListener('keydown', function (event) {
            let key = 0;

            if (event.key !== undefined) {
                key = event.key;
            } else if (event.keyIdentifier !== undefined) {
                key = event.keyIdentifier;
            } else if (event.keyCode !== undefined) {
                key = event.keyCode;
            }

            switch (key) {
                case 'Escape':
                case 27:{
                    that.escPressed();
                }break;
            }
        });
    },
};
